export type ComplianceDocumentRegenerateDocumentType =
  | 'instruction_handbook'
  | 'risk_assessment'

export type SectionRegenerateDisclaimerMode =
  | 'agentWithEdits'
  | 'handbookSafety'
  | 'applicableRegulations'
  | 'relevantStandards'
  | 'hazardIdentification'
  | 'staticRefresh'
  | 'customUnsupported'

type ResolveSectionRegenerateDisclaimerModeInput = {
  documentType: ComplianceDocumentRegenerateDocumentType
  sectionId: string
  sectionKind?: 'canonical' | 'custom'
}

const RISK_ASSESSMENT_STATIC_SECTION_IDS = new Set(['2', '2.1'])

export function resolveSectionRegenerateDisclaimerMode({
  documentType,
  sectionId,
  sectionKind,
}: ResolveSectionRegenerateDisclaimerModeInput): SectionRegenerateDisclaimerMode {
  if (sectionKind === 'custom') {
    return 'customUnsupported'
  }

  if (documentType === 'instruction_handbook') {
    if (sectionId === '2') {
      return 'handbookSafety'
    }
    return 'agentWithEdits'
  }

  if (sectionId === '2.2') {
    return 'applicableRegulations'
  }
  if (sectionId === '2.3') {
    return 'relevantStandards'
  }
  if (sectionId === '8') {
    return 'hazardIdentification'
  }
  if (RISK_ASSESSMENT_STATIC_SECTION_IDS.has(sectionId)) {
    return 'staticRefresh'
  }

  return 'agentWithEdits'
}
